export default "__VITE_ASSET__CV_fsFnS__"